var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrencyActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2085 5.31194C20.4974 3.26073 18.1507 1.83926 15.5403 1.27283C12.9299 0.706401 10.205 1.02741 7.79772 2.18497C5.39039 3.34254 3.43826 5.27045 2.25073 7.66314C1.06319 10.0558 0.708192 12.7764 1.24199 15.3937M24.6766 10.2401C25.3065 12.8981 25.0105 15.6915 23.8374 18.1584C22.6643 20.6253 20.6845 22.618 18.2252 23.807C15.7659 24.996 12.9744 25.3101 10.3124 24.6973C7.65039 24.0845 5.27721 22.5816 3.58528 20.437",
    stroke: "#7607BD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7973 2.60156V5.8006H19.5982M6.40217 20.1963H3.20312V23.3953",
    stroke: "#7607BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.60156V19.3977",
    stroke: "#7607BD",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8951 10.0454C15.7031 9.19762 14.6106 8.25391 13.0095 8.25391C11.4084 8.25391 10.1784 9.2936 10.1784 10.6052C10.1784 13.5867 16.1142 12.0544 16.1142 15.5157C16.1142 16.765 14.6106 17.8254 13.0111 17.8254C11.4116 17.8254 10.3015 16.8417 9.97363 15.7876",
    stroke: "#7607BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyActive);
export default __webpack_public_path__ + "static/media/currencyActive.5f269eb08ad8f5e5ec33bf2fd799f4e7.svg";
export { ForwardRef as ReactComponent };